module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "esia",
    attrs: {
      "href": _vm.esiaLink
    },
    on: {
      "click": _vm.saveUrl
    }
  }, [_vm._v("Вход через"), _c('span', {
    staticClass: "esia__ico"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-709028a3","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/esialink/Esia.vue
// module id = 08d8aefbf1b7efa601fc
// module chunks = 89